import { Injectable } from '@angular/core';





import { Router } from '@angular/router';
/**  
 * ```
 * 
 * (  Gues who is back AGAIN!  )
 *            \ |         .--.  .--.
                    /    \/    \
                   | .-.  .-.   \
                   |/_  |/_  |   \
                   || `\|| `\|    `----.
                   |\0_/ \0_/    --,    \_
 .--"""""-.       /              (` \     `-.
/          \-----'-.              \          \
\  () ()                         /`\          \
|                         .___.-'   |          \
\                        /` \|      /           ;
 `-.___             ___.' .-.`.---.|             \
    \| ``-..___,.-'`\| / /   /     |              `\
     `      \|      ,`/ /   /   ,  /
             `      |\ /   /    |\/
              ,   .'`-;   '     \/
         ,    |\-'  .'   ,   .-'`
       .-|\--;`` .-'     |\.'
      ( `"'-.|\ ____,.--'`'   
       `-.    `"`          _.--'
          `.          _.-'`-.
            `''---''``       `.
 */
@Injectable({ providedIn: 'root' })
export class TheNaviGator {
  constructor(private router: Router) {
  }
  /**
   * Helper to read url for type.
   * -located here so url names are contained into a singular class/service
   * @param url 
   * @returns 
   */
  Is_Viewer_Url(url: string) {
    if (!url || url == "") {
      return false;
    }
    if (url.indexOf('/') <= -1) {
      return false;
    }
    return (url.split('/')[1] === 'view' || url.split('/')[1] === 'download');
  }
  // Create Urls:
  /**
   * Creates and returns the Viewer Url
   * @param requestGuid 
   * @returns 
   */
  Viewer_Url(requestGuid: string): string {
    return "/view/" + requestGuid;
  }
  /**
   * Creates and returns the DOWNLOAD version of Viewer Url
   * @param requestGuid 
   * @returns 
   */
  Download_Url(requestGuid: string): string {
    return "/download/" + requestGuid;
  }


  // Navigate to 'Modules':
  /**
   * Generates the Viewer url (Serialized) for opening in a new Tab
   * @param requestGuid 
   * @returns 
   */
  To_Viewer_In_A_New_Window(requestGuid: string) {
    let url = this.router.serializeUrl(this.router.createUrlTree([this.Viewer_Url(requestGuid)]));
    window.open(url, '_blank');
  }
  /**
   * Redirect to the Dashboard/Home
   */
  To_Dashboard() {
    this.router.navigate(["/dashboard"]);
  }
  /**
   * Redirect to the Builder to create a mew request by the given Workflow
   * @param workflowGuid 
   * @param requestGuid (optional for when opening an existing request)
   */
  To_Build(workflowGuid: string | null, requestGuid: string | null | undefined = null) {
    if (requestGuid !== null && requestGuid !== undefined && requestGuid !== "undefined") {
      this.router.navigate(["/build/" + requestGuid + ""], { queryParams: { workflowId: workflowGuid } });
    } else {
      this.router.navigate(["/build"], { queryParams: { workflowId: workflowGuid } });
    }
  }
  /**
   * Redirect to the Status Page/Module for the given Request
   * @param requestGuid 
   */
  To_Status(requestGuid: string) {
    this.router.navigate(["/request/" + requestGuid]);
  }


  // Navigate to 'Pages':
  /**
   * Redirects to the invite not found error page
   */
  To_InviteNotFound() {
    this.router.navigate(["/invite-not-found"])
  }
  /**
   * Redirect to the Unauthorized Page
   * @param returnUrl 
   */
  To_Unauthorized(returnUrl: string) {
    this.router.navigate(['/unauthorized'], { queryParams: { returnUrl: returnUrl } });
  }
  /**
   * Redirect to the Login Page
   * @param returnUrl 
   */
  To_Login(returnUrl: string | null | undefined = null) {
    if (returnUrl !== null && returnUrl !== undefined && returnUrl !== "undefined") {
      this.router.navigate(['/login'], { queryParams: { 'returnUrl': returnUrl } });
    }
    else {
      this.router.navigate(['/login']);
    }
  }
  /**
   * Redirects to the Onboarding completed page
   */
  To_OnboardingCompleted() {
    this.router.navigate(["/onboardingcompleted"])
  }


  // Navigate to what is given:
  /**
   * Redirect to given Url
   * @param url 
   */
  To_Url(url: string) {
    this.router.navigateByUrl(url);

  }

}